import React, { FC } from 'react';
import { AdfoxNew } from '../../adfox/adfoxNew';
import { ADFOX_NEW_MEDIA_CONSTANTS } from '../../adfox/constants';

const POST_VIEW_ANALYTICS_DATA = {
  place: 'filters' as const,
  place__DEPRECATED: 'maintage',
  name__DEPRECATED: 'maintage_brand_filters',
};

export const CountrysideBrandBanner: FC = () => {
  return <AdfoxNew constants={ADFOX_NEW_MEDIA_CONSTANTS} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} />;
};
